export const getSizeByRef = target => {
    const {clientWidth, clientHeight} = target.current;
    return {
        width: clientWidth,
        height: clientHeight
    };
};